import React, { useState, useEffect } from "react"
// import {NoResultProperties} from '../../queries/common_use_query';
// import PropertyItem from "../property-item/property-item";
import gql from "graphql-tag"
import Cookies from "universal-cookie"
import ScrollAnimation from "react-animate-on-scroll"
import { ShowProcessedImage } from "../../Components/Common/ggfx-client/module/components/show-image"
import imageConfig from "../../../static/images/config.json"
import { Link, PropertyCallTo } from "@StarberryUtils"
import { useQuery } from "@apollo/client"
import GetImageCount from "../../Components/getpropertyimagecount"
import ImageTransform from "../../Components/Common/ggfx-client/module/components/image-transform"
// import ImageTransform from "../../Common/ggfx-client/module/components/image-transform"

const mycookies = new Cookies()
//property description
let text_truncate = function (str, length, ending) {
  if (length == null) {
    length = 150
  }
  if (ending == null) {
    ending = "..."
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending
  } else {
    return str
  }
}
const NoResultProperties = gql`
  query NoResultProperties($status: String!, $department: String!) {
    properties(
      limit: 6
      where: { status: $status, department: $department, publish: true }
    ) {
      id
      display_address
      search_type
      status
      slug
      title
      department
      price
      images
      negotiator_details
      bedroom
      reception
      bathroom
      office_details
      office_crm_id
      imagetransforms
      description
    }
  }
`

const PropertyNoResult = props => {
  const [department, setDepartment] = useState("residential")
  useEffect(() => {
    props.department && setDepartment(props.department)
  }, [props.department])
  const { loading, error, data } = useQuery(NoResultProperties, {
    variables: { status: props.status, department: department },
  })
  // const {loading:loading, error:error, data:data} = NoResultProperties(, department);
  console.log(data, "dddd")
  return (
    <React.Fragment>
      {data && data.properties.length > 0 && (
        <>
          <p class="results-page-wrapper mb-5">
            We have selected some of our properties for you to browse below.
            Alternatively, you can search again in the bar above.
          </p>
          {data.properties.map((hit, i) => {
            // property details url structure
            let uriStr = ""

            if (
              hit.search_type === "sales" &&
              hit.department === "residential"
            ) {
              uriStr = `property-for-sale/`
            } else if (
              hit.search_type === "lettings" &&
              hit.department === "residential"
            ) {
              uriStr = `property-to-rent/`
            }
            // property details url structure

            let processedImages = JSON.stringify({})
            if (hit?.imagetransforms?.images_Transforms) {
              processedImages = hit.imagetransforms.images_Transforms
            }

            return (
              <>
                <div
                  className="mbot col-xl-6 mysingleproperty property-list-card"
                  key={i}
                  id={`${hit.id}`}
                  data-objectid={hit.id}
                  data-lat={hit?._geoloc?.lat}
                  data-lng={hit?._geoloc?.lng}
                  onClick={() =>
                    mycookies.set("mySaleProp", hit.id, {
                      path: "/",
                      maxAge: 300,
                    })
                  }
                  // state={{ referrer: props.location.pathname }}
                >
                  <ScrollAnimation
                    duration={0.5}
                    animateIn="fadeInUp"
                    offset={0}
                    animateOnce={true}
                    className="property-results-card"
                  >
                    <div className="property-details">
                      <div className="property-image-block">
                        <Link to={`/${uriStr}${hit.slug}-${hit.id}`}>
                          <picture>
                            <ImageTransform
                              imagesources={hit.images && hit.images[0]?.url}
                              renderer="srcSet"
                              imagename="property.images.detail"
                              attr={{
                                alt:
                                  hit.display_address + " - Location Location",
                              }}
                              imagetransformresult={processedImages}
                              id={hit.id}
                              testparam={true}
                            />
                          </picture>
                        </Link>
                        <GetImageCount id={hit.id} />
                        {hit.status.trim().toLowerCase().replace(/ /g, "_") == "under_offer" ? (
                          <span className="category-tag">Under Offer</span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="property-content-block no-result">
                      {/* <h2> */}
                      <Link
                        to={`/${uriStr}${hit.slug}-${hit.id}`}
                        className="btn-text-link"
                      >
                        <h2> {hit.display_address}</h2>

                        {/* </h2> */}

                        {hit.price ? (
                          <p className="amount">
                            &pound;{hit.price.toLocaleString()}
                          </p>
                        ) : (
                          ""
                        )}
                        {hit.title ? (
                          <p className="small-desc">
                            {hit.title.replace(/-/g, " ")}
                          </p>
                        ) : (
                          ""
                        )}
                        {hit.description ? (  
                              <div
                                  className="large-desc" 
                                  dangerouslySetInnerHTML={{
                                    __html:
                                    hit.description.slice(0, 150) +
                                      "... ",
                                  }}
                                /> 
                          ) : (
                            ""
                        )}
                        <div className="search-list-content-new">
                          <ul>
                            {hit.bedroom > 0 && (
                              <li className="bedroom">
                                <i className="icon-bed"></i>
                                <p>
                                  {hit.bedroom > 1
                                    ? hit.bedroom + " Bedrooms"
                                    : hit.bedroom + " Bedroom"}
                                </p>
                              </li>
                            )}
                            {hit.bathroom > 0 && (
                              <li className="Bathrooms">
                                <i className="icon-bathroom"></i>
                                <p>
                                  {hit.bathroom > 1
                                    ? hit.bathroom + " Bathrooms"
                                    : hit.bathroom + " Bathroom"}
                                </p>
                              </li>
                            )}

                            {hit.reception > 0 && (
                              <li className="reception">
                                <i className="icon-reception"></i>
                                <p>
                                  {hit.reception > 1
                                    ? hit.reception + " Receptions"
                                    : hit.reception + " Reception"}
                                </p>
                              </li>
                            )}
                            {/* {hit.garden > 0 && (
                                        <li className="garden">
                                          <i className="icon-garden"></i>
                                          <p>{hit.garden > 1
                                                      ? hit.garden + " Private Gardens"
                                                      : hit.garden + " Private Garden"}
                                                      </p>
                                        </li>
                                        )} */}
                            {/* <li className="chainfree">
                                  <i className="icon-chainfree"></i>
                                  <p>Chain Free</p>
                                </li> */}
                          </ul>
                        </div>
                        {/* <ul className="desc-list">
                                        <TransportList
                                          id={hit.objectID}
                                          latitude={parseFloat(hit._geoloc.lat)}
                                          longitude={parseFloat(hit._geoloc.lng)}
                                        />
                                      </ul> */}
                        <div className="list-enquiry">
                          {/* <GetOffice phone={hit.office_details && hit.office_details.telephone}/> */}

                          <p className="enquiry-text">
                            <span>
                              <Link
                                className="border-bottom-yellow"
                                key={i}
                                id={`mySaleProp${hit.id}`}
                                data-objectid={hit.id}
                                data-lat={hit?._geoloc?.lat}
                                data-lng={hit?._geoloc?.lng}
                                onClick={() =>
                                  mycookies.set("mySaleProp", hit.id, {
                                    path: "/",
                                    maxAge: 300,
                                  })
                                }
                                to={`/${uriStr}${hit.slug}-${hit.id}/?id=booking`}
                                //   state={{ referrer: props.location.pathname }}
                              >
                                Book a Viewing
                              </Link>{" "}
                              {PropertyCallTo(hit.office_crm_id) &&
                                <>
                                  or call{" "}
                                  <a
                                    className="border-bottom-yellow-slide"
                                    href={`tel: ${PropertyCallTo(hit.office_crm_id)}`}
                                  >
                                    {PropertyCallTo(hit.office_crm_id)}
                                  </a>
                                </>
                                }
                            </span>
                          </p>
                        </div>
                      </Link>
                    </div>
                  </ScrollAnimation>
                </div>
              </>
            )
          })}
        </>
      )}
    </React.Fragment>
  )
}

export default PropertyNoResult
